module.exports = __webpack_public_path__ + "static/media/uanalytics-illustrator.515b83f7.svg";